import type { Action } from "../../actions/types";

export interface LedgerActivityRecord {
  id: string;
  createdOn: string;
  currency: string;
  description: string;
  value: number;
  sourceName?: string;
  expirationDate: string;
  creditSource?: string;
  target?: {
    id: string;
    type: string;
  };
}

export type StoreState = LedgerActivityRecord[];

export const initialState = [];

export function reducer(
  state: StoreState | null = initialState,
  action: Action
): StoreState | null {
  if (action.type === "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS") {
    return action.response.data.records;
  }

  return state;
}
